/**
 * apiの値をフォーム用のデフォルト値に変換する
 */
export const getHotlineClientReorderDefaultValues = (reorder) => {
    if (reorder === null) {
        return null;
    }
    return {
        adviceRequest: reorder.advice_request,
        description: reorder.description,
        disclose: reorder.disclose,
        industry: reorder.industry,
        sales: reorder.sales,
        title: reorder.title,
    };
};
